import { Injectable } from '@angular/core';
// tslint:disable-next-line:import-spacing
import {HttpClient, HttpHeaders, HttpParams} from'@angular/common/http';
import {Observable} from 'rxjs';
const  headers  =  new  HttpHeaders({'Content-Type': 'application/json;charset:utf-8', 'Access-Control-Allow-Origin': '*',
 'Access-Control-Allow-Credentials': 'true', 'Access-Control-Allow-Methods': 'GET, POST, PATCH, PUT, DELETE, OPTIONS'});

@Injectable()
export class AuditService {

  auditUrl = '/superadmin/rest/mgmt/auditlog?';
  countUrl = '/superadmin/rest/mgmt/auditlog/count?';
  // getAudits(): Observable<any> {

  //   return this.http.get(this.auditUrl,{headers:headers})
  // }
  constructor(private http: HttpClient) { }

  getAudits(
    filter, sortOrder,
    pageNumber, pageSize = 10):  Observable<any> {

    return this.http.get(this.auditUrl + filter, {
        params: new HttpParams()
            .set('asc', sortOrder)
            .set('from', pageNumber.toString())
            .set('count', pageSize.toString())
    });
}
// Get total count of audits
getCount(): Observable<any> {
  return this.http.get(this.countUrl, {headers});
}
getTotalFilterCount(filter): Observable<any> {
  return this.http.get(this.countUrl + filter, {headers});
}

}
